var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"28","height":"2","style":{"fill":"var(--content-color, var(--color-black))"},"key":0}),React.createElement("rect",{"y":"14","width":"28","height":"2","style":{"fill":"var(--content-color, var(--color-black))"},"key":1})]);
}

Menu.defaultProps = {"width":"28","height":"16","viewBox":"0 0 28 16","fill":"none"};

module.exports = Menu;

Menu.default = Menu;
